import { supabase } from '../lib/supabase';

// Test function to check if offers table exists and is accessible
export const testOffersTable = async () => {
  try {
    console.log('Testing offers table...');
    
    // Try to query the offers table
    const { data, error } = await supabase
      .from('offers')
      .select('*')
      .limit(1);
    
    if (error) {
      console.error('Error accessing offers table:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Offers table is accessible:', data);
    return { success: true, data };
  } catch (error: any) {
    console.error('Exception testing offers table:', error);
    return { success: false, error: error.message };
  }
};

// Test function to check user authentication
export const testUserAuth = async () => {
  try {
    console.log('Testing user authentication...');
    
    const { data: { user }, error } = await supabase.auth.getUser();
    
    if (error) {
      console.error('Error getting user:', error);
      return { success: false, error: error.message };
    }
    
    if (!user) {
      console.error('No user found');
      return { success: false, error: 'No user found' };
    }
    
    console.log('User authenticated:', user.id);
    return { success: true, user };
  } catch (error: any) {
    console.error('Exception testing user auth:', error);
    return { success: false, error: error.message };
  }
};
